import React from "react";
import { Typography, Button, makeStyles } from "@material-ui/core";
const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: "none",
    marginBottom: "1.2em",
    backgroundColor: "#026FC2",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#0252c2",
      color: "#ffffff",
    },
  },
}));

const DEFAULT_BUTTON_WIDTH = "10em";
const DEFAULT_BUTTON_HEIGHT = "3.5em";

const NtkButton = ({
  width,
  height,
  title,
  type = null,
  handleClick = null,
  href,
}) => {
  const classes = useStyles();
  return (
    <Button
      style={{
        width: width ? width : DEFAULT_BUTTON_WIDTH,
        height: height ? height : DEFAULT_BUTTON_HEIGHT,
      }}
      type={type}
      onClick={handleClick}
      key="ntkButton"
      data-testid="ntkButton"
      className={classes.button}
      variant="outlined"
      color="primary"
      href={href}
    >
      <Typography variant="subtitle1" color="inherit">
        {title}
      </Typography>
    </Button>
  );
};

export default NtkButton;
